import axios from '../_utils/axios';
import store, { DELETE_LOADER, persistor } from '../../store';
import userAgent from '../../utils/user-agent';
import logout from '../auth-account/logout';

// ----------------------------------------------------------------------

const changePassword = async (currentPassword: string, newPassword: string, temp?: boolean) => {
  return await axios.put(`accounts/${temp ? 'temp-' : ''}password`, {currentPassword, newPassword})
    .catch((error) => {
      const code = error.response.data.code;
      
      if ( error.code === 'ERR_BAD_RESPONSE' ) {
        persistor.purge();
        window.location.href = '/alert';
      } else if ( code === 'ERR-001' || code === 'ERR-REISSUE' ) {
        persistor.purge();
        window.location.href = '/login';
      } else if ( code === 'ERR-023' || code === 'ERR-025' ) {
        alert(code === 'ERR-023' ? '비밀번호 오류 횟수 초과로 인해 회원님의 접속이 제한되었습니다.\n비밀번호 찾기 페이지를 이용해 비밀번호를 재설정해 주세요.' : '임시 비밀번호의 유효 기간이 만료되었습니다.\n임시 비밀번호를 재발급해 주세요.');
        const UA = userAgent();
        return logout(UA, '/login');
      } else {
        return Promise.reject(
          new Error( code === 'ERR-024' ?
            '비밀번호를 다시 한번 확인해 주세요.'
            : '비밀번호를 변경할 수 없습니다. 나중에 다시 시도해 주세요.'
          )
        );
      }
    })
    .finally(() => store.dispatch( DELETE_LOADER() ));
};

export default changePassword;